/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import User from './User';

/**
 * The PaginatedUsersResponse model module.
 * @module model/PaginatedUsersResponse
 * @version 1.0.0
 */
class PaginatedUsersResponse {
    /**
     * Constructs a new <code>PaginatedUsersResponse</code>.
     * @alias module:model/PaginatedUsersResponse
     */
    constructor() { 
        
        PaginatedUsersResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedUsersResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedUsersResponse} obj Optional instance to populate.
     * @return {module:model/PaginatedUsersResponse} The populated <code>PaginatedUsersResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedUsersResponse();

            if (data.hasOwnProperty('total_count')) {
                obj['total_count'] = ApiClient.convertToType(data['total_count'], 'Number');
            }
            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
            if (data.hasOwnProperty('users')) {
                obj['users'] = ApiClient.convertToType(data['users'], [User]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedUsersResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedUsersResponse</code>.
     */
    static validateJSON(data) {
        if (data['users']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['users'])) {
                throw new Error("Expected the field `users` to be an array in the JSON data but got " + data['users']);
            }
            // validate the optional field `users` (array)
            for (const item of data['users']) {
                User.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * 全ユーザー数
 * @member {Number} total_count
 */
PaginatedUsersResponse.prototype['total_count'] = undefined;

/**
 * 現在のページ
 * @member {Number} current_page
 */
PaginatedUsersResponse.prototype['current_page'] = undefined;

/**
 * 1ページあたりの件数
 * @member {Number} per_page
 */
PaginatedUsersResponse.prototype['per_page'] = undefined;

/**
 * @member {Array.<module:model/User>} users
 */
PaginatedUsersResponse.prototype['users'] = undefined;






export default PaginatedUsersResponse;

